export default "__VITE_ASSET__D7ZO9pzk__"